import { Span } from '@components/Components/Reusables/Typography/P'
import { isDefined } from '@components/config/helpers';
import AddToCartButton from '@components/Custom/Buttons/AddToCartButton'
import React, { useEffect, useState } from 'react'

export default function ProductPackageCoreOption(props) {
    const {package_core, core_option, disabled, setMasterPackage, selectedPackage} = props;
    const [value, setValue] = useState(Number(core_option.package_core_option_min_value))

    useEffect(() => {
        setValue(Number(core_option.package_core_option_min_value));
    }, [selectedPackage])
    

    const minValue = Number(core_option.package_core_option_min_value);
    const maxValue = Number(core_option.package_core_option_max_value);
    const incValue = Number(core_option.package_core_option_increment_value);

    const handleQtyChange = (event, type = null) => {

        let productQty = event.target.value;
        if(!isDefined(productQty)) productQty = value;

        const changedByButton = type == 'add' || type == 'subtract';
        if (isNaN(productQty) && !changedByButton) return;

        // If we are using the text input
        if(type == null){
            if(productQty > maxValue){
                event.target.value = maxValue;
            }
            else if(productQty < minValue){
                event.target.value = minValue;
                productQty = minValue;
            }
        } 
        
        // If we are triggering on blur event
        else if(type == 'blur'){
            if(productQty > maxValue){
                event.target.value = maxValue;
                productQty = maxValue;
            }
            else if(productQty < minValue){
                event.target.value = minValue;
                productQty = minValue;
            }
        }

        // If we are using the buttons + or -
        else {
            if(type == 'add' || type == 'subtract'){
              
                if(type == 'add') {
                    if(productQty < maxValue){
                        productQty = (productQty + incValue);
                    }
                }
                else if(type == 'subtract'){
                    if(productQty > minValue){
                        productQty = (productQty - incValue);
                    }
                  if(productQty <= 0) productQty = 1;
                }
            }
        }

        if(productQty <= 0) productQty = 1;

        if(productQty < minValue){
            event.target.value = minValue;
            return;
        }
        if(productQty > maxValue){
            event.target.value = maxValue;
            return;
        }

        setValue(Number(productQty));

        if(type == null){
            productQty = event.target.value;
            setValue(Number(productQty));
        }
        
        setMasterPackage((prevState) => {
            const prev = [...prevState];
            const current_index = prevState.findIndex(prev_core_option => prev_core_option.package_core_option_id == core_option.package_core_option_id);
            if(current_index != -1){
                prev[current_index].qty = productQty
            }
            return prev;
        })
    };
    
    return (
        <div className="d-flex margin-auto" key={core_option.package_core_option_id}>
            <div className="text-center margin-auto">
                <Span className="text-center grey fs-10">{core_option.package_core_option_name}</Span>
                <AddToCartButton 
                    disabled={disabled} 
                    // dec_disabled={minValue == value} 
                    // inc_disabled={maxValue == value} 
                    handleQtyChange={handleQtyChange} 
                    value={value}
                />
            </div>
        </div>
    )
}
